import React from 'react';
import BarSplitChart from './BarSplitChart';
import { getCountryName } from '../../../utils/countries';

// India is excluded by business decision; codes become display names. "Others"
// (the backend's tail rollup) has no ISO code, so getCountryName leaves it as-is.
const excludeIndiaAndName = (rows) =>
  rows
    .filter((r) => String(r.name || '').trim().toUpperCase() !== 'IN')
    .map((r) => ({ ...r, name: getCountryName(String(r.name || '').trim()) || r.name }));

// By default only the higher-volume countries (5+ vendors) get their own bar;
// the long tail of low-count countries (Germany, Israel, and the many single-
// vendor countries) is folded into a clickable "Others" bar that expands the
// chart to the full list on demand. No maxRows — collapsing, not truncation,
// keeps every country reachable.
const CountrySplitChart = () => (
  <BarSplitChart
    title="Split Over Country"
    endpoint="/dashboard/country-split"
    cornerLabel="descending"
    barColor="var(--dash-chart-3)"
    transform={excludeIndiaAndName}
    collapseBelow={5}
  />
);

export default CountrySplitChart;
